import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
declare function testrun(): void;
@Component({
    templateUrl: './AppViews/ProjectList/projectList.html'
})


export class ProjectListComponent implements OnInit {


    constants: Constants;
    projectListItems: any = [];
    teamItems: any[] = [];
    projectTypeItems: any = [];
    projectStatusItems: any = [];
    userDetail: any;
    selfuser: boolean = true;
    filter: any = { 'TeamId': "", 'TypeId': "", 'StatusId': "" };
    Search: any = "";
    public showLoader = false;
    projectFilterFlag: any;
    getProjectUrl: any;
    showcomments: boolean = false;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter.StatusId = this.constants.enumProjectStatus["Open"];
        this.filter.TeamId = "";
        this.projectFilterFlag = JSON.parse(localStorage.getItem('ProjectFilters'));
        if (this.userDetail.RoleId == 3) {
            this.getProjectUrl = "Project/GetAssignedProject"
        } else {
            this.getProjectUrl = "Project/GetProjectNew"
        }
        if (this.projectFilterFlag != null && typeof this.projectFilterFlag != 'undefined') {
            this.filter = JSON.parse(localStorage.getItem('ProjectFilters'));
            this.Search = this.filter.Search;
            localStorage.removeItem("ProjectFilters")
        }
    }

    ngOnInit() {
        this.BindFilters();
        this.GetProjectList(true);
    }

    GetProjectList(flag: boolean) {
        debugger;
        this.selfuser = flag;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        if (this.filter.TeamId == "") {
            //to handle executives case
            //  if(this.userDetail.RoleId==3){
            TeamId = 0
            //  }else{
            //     TeamId = this.userDetail.TeamID;
            //  }
        }
        else {
            TeamId = this.filter.TeamId;
        }
        this.showLoader = true;
        this._httpService.ajaxPost(this.getProjectUrl,
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": this.filter.TypeId, "Status": this.filter.StatusId, "UserId": UserId }).subscribe(
            data => {
                this.projectListItems = data["ProjectList"];
                this.projectListItems.forEach(element => {
                    if (element.Status_Comments != null && element.Status_Comments != "") {
                        if (element.Status_Comments.length >= 100) {
                            // element.Status_Comments=element.Status_Comments.substring(0,100);
                            element.showcomments = true;
                            element.alteredComments = element.Status_Comments.substring(0, 100) + "....";
                        } else {
                            element.alteredComments = element.Status_Comments
                            element.showcomments = false;
                        }
                    }
                    if (element.End_Date != null && element.End_Date != "") {
                        var dateParts = element.End_Date.split("/");
                        var expiryDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                        var today = new Date(); // Start Added by mohsin - 11/05/2026
                        today.setHours(0, 0, 0, 0);
                        console.log('stage',element.Stage)
                        if(element.Stage == 8){
                            if (expiryDate < today) {
                                element.isExpired = true;
                            } else {
                                element.isExpired = false;
                            }
                            var DateDiff = expiryDate.getTime() - today.getTime()
                            const daysLeft = Math.ceil(DateDiff / (1000 * 3600 * 24));
                            console.log(element.Project_Id+'- DateDiff', daysLeft)
                            if(daysLeft >= 0 && daysLeft <= 45){
                                element.aboutToExipire = true;
                            }else{
                                element.aboutToExipire = false;
                            } 
                        } //End Added by mohsin - 11/05/2026
                        element.EndDateSort = expiryDate.getTime();
                    }
                });
                this.showLoader = false;
            },
            err=> {
              
                debugger;
                console.log("GetProjectList Failed fdgdfg");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            // () => {
            //     debugger;
            //     console.log("GetProjectList " + this.selfuser);
            //     this.showLoader = false;
            // }
            );

        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    //    public getPopOver()
    //     {
    //             $(".pop-comment").popover({
    //                 //content: 'test'
    //                 content: function() {
    //                     return $(this).parent().find('p').html();
    //                 }
    //             });

    //     }

    ngAfterViewInit() {
        $(".datemonthYear").datetimepicker({
            format: 'MM/YYYY'
        });
        $(".time").datetimepicker({
            format: 'HH:mm'
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
        $(".showComments").tooltip('show');
        // setTimeout(function(){
        //     var showChar = 15; 
        //     var ellipsestext = "...";
        //     var moretext = "See More";
        //     var lesstext = "See Less";
        //     $('.comments-space').each(function () {
        //         var content = $(this).html();                    
        //         if (content.length > showChar) {                    
        //             var show_content = content.substr(0, showChar);                  
        //             var hide_content = content.substr(showChar, content.length - showChar);
        //             var html = show_content + '<span class="moreelipses">' + ellipsestext + '</span><span class="remaining-content"><span>' + hide_content + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';
        //             $(this).html(html);                    
        //         }                
        //     });

        //     $(".morelink").click(function () {
        //         if ($(this).hasClass("less")) {
        //             $(this).removeClass("less");
        //             $(this).html(moretext);
        //         } else {
        //             $(this).addClass("less");
        //             $(this).html(lesstext);
        //         }
        //         $(this).parent().prev().toggle();
        //         $(this).prev().toggle();
        //         return false;
        //     }); 
        //   },1500);        

    }




    BindFilters() {

        this.showLoader = true;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
        //     TeamId = this.userDetail.TeamID;
        }
       // if(this.filter.TeamId==""){
        TeamId = 0

        // }
        // else{
        //     TeamId = this.filter.TeamId;
        // }
        this._httpService.ajaxPost(this.getProjectUrl,
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": "", "Status": this.filter.StatusId, "UserId": UserId }).subscribe(
            data => {
                var projectList = data["ProjectList"];
                projectList.forEach(element => {
                    var isFound = false;
                    for (var i = 0; i < this.teamItems.length; i++) {
                        if (this.teamItems[i].OwnerTeam_Id == element.OwnerTeam_Id) {
                            isFound = true;
                            break;
                        }
                    }
                    if (isFound == false) {
                        if (element.OwnerTeam != "" && element.OwnerTeam != null) {
                            this.teamItems.push({ "OwnerTeam_Id": element.OwnerTeam_Id, "OwnerTeam": element.OwnerTeam });
                        }
                    }
                });
                this.teamItems.sort(function (a, b) { if (a.OwnerTeam.toLowerCase() < b.OwnerTeam.toLowerCase()) return -1; if (a.OwnerTeam.toLowerCase() > b.OwnerTeam.toLowerCase()) return 1; return 0; })
                //   console.log(this.teamItems);
            },
            err => {
                console.log("BindFilters Failed");
                this.showLoader = false;
                // this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
            this.showLoader = true;
                this._httpService.ajaxPost('Common/GetParameter',
                    { "ParameterTypeId": this.constants.enumParamterTypeName["ProjectType"] }).subscribe(
                    data => {
                        this.projectTypeItems = data["Parameter"];
                        // this.projectTypeItems.sort(function (a, b) { if (a.ParameterDescription.toLowerCase() < b.ParameterDescription.toLowerCase()) return -1; if (a.ParameterDescription.toLowerCase() > b.ParameterDescription.toLowerCase()) return 1; return 0; })
                    },
                    err => {
                        console.log("BindFilters Failed");
                        this.showLoader = false;
                        // this._sharedService.ShowMessage(this.constants.globalError);
                    },
                    () => {
                    this.showLoader = true;
                        this._httpService.ajaxPost('Common/GetParameter',
                            { "ParameterTypeId": this.constants.enumParamterTypeName["ProjectStatus"] }).subscribe(
                            data => {
                                this.projectStatusItems = data["Parameter"];

                            },
                            err => {
                                console.log("BindFilters Failed");
                                this.showLoader = false;
                                // this._sharedService.ShowMessage(this.constants.globalError);
                            },
                            () => {
                                this.showLoader = false;
                            }
                            );
                        this.showLoader = false;
                     }
                     );
                this.showLoader = false;
            }
            );
          //  this.GetProjectList(true);
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }


    // BindFilters() {

    //     this.showLoader = true;
    //     var UserId = 0;
    //     var TeamId = 0;
    //     if (this.userDetail.RoleId != 0) {
    //         UserId = this.userDetail.SiteUserId;
    //         //TeamId = this.userDetail.TeamID;
    //     }
    //     //if(this.filter.TeamId==""){
    //     TeamId = 0

    //     //}
    //     // else{
    //     //     TeamId = this.filter.TeamId;
    //     // }
    //     this.showLoader = true;
    //     this._httpService.ajaxPost('Common/GetParameter',
    //         { "ParameterTypeId": this.constants.enumParamterTypeName["ProjectType"] }).subscribe(
    //         data => {
    //             this.projectTypeItems = data["Parameter"];
    //             // this.projectTypeItems.sort(function (a, b) { if (a.ParameterDescription.toLowerCase() < b.ParameterDescription.toLowerCase()) return -1; if (a.ParameterDescription.toLowerCase() > b.ParameterDescription.toLowerCase()) return 1; return 0; })
    //         },
    //         err => {
    //             console.log("BindFilters Failed");
    //             this.showLoader = false;
    //             // this._sharedService.ShowMessage(this.constants.globalError);
    //         },
    //         () => {
    //         this.showLoader = true;
    //             this._httpService.ajaxPost('Common/GetParameter',
    //                 { "ParameterTypeId": this.constants.enumParamterTypeName["ProjectStatus"] }).subscribe(
    //                 data => {
    //                     this.projectStatusItems = data["Parameter"];

    //                 },
    //                 err => {
    //                     console.log("BindFilters Failed");
    //                     this.showLoader = false;
    //                     // this._sharedService.ShowMessage(this.constants.globalError);
    //                 },
    //                 () => {
    //                     this.showLoader = false;
    //                 }
    //                 );
    //             this.showLoader = false;
    //         }
    //         );
    //     this.showLoader = false;

    //     setTimeout(function () {
    //         $(".pop-comment").popover({
    //             //content: 'test'
    //             content: function () {
    //                 return $(this).parent().find('p').html();
    //             }
    //         });
    //     }, 500);
    // }

    public clearFilter() {
        this.filter.TypeId = "";
        this.filter.TeamId = "";
        this.filter.StatusId = this.constants.enumProjectStatus.Open;
        this.Search = "";

        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    setFilters() {
        this.filter = { 'StatusId': this.filter.StatusId, 'TypeId': this.filter.TypeId, 'TeamId': this.filter.TeamId, 'Search': this.Search };
        localStorage.setItem("ProjectFilters", JSON.stringify(this.filter));
    }

    showComments(ev, dt) {
        dt.flag = true;
        if (ev.srcElement.className == "showComments" && dt.flag == true) {
            ev.srcElement.id = "shwComments";
            $("#shwComments").tooltip('show');
        }
    }
    removeId(ev) {
        if (ev.srcElement.className == "showComments" && ev.srcElement.id == "shwComments") {
            ev.srcElement.id = "";
        }
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ProjectList/projectList.component.ts
 **/